import { Meta } from "@/shared/components";
import { CollectionTypes } from "@/admin/features/collectionTypes";

/**
 * Страница управления типами коллекций
 */
export function CollectionTypesPage() {
  return (
    <>
      <Meta title="Типы коллекций" />
      <CollectionTypes />
    </>
  );
}
